import {Injectable} from '@angular/core';
import {Response, Headers, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Message} from '../models/message';
import 'rxjs/add/operator/map';
import { Poll } from '../models/poll';

@Injectable()
export class PollService {

  private pollUrl = `${ environment.apiRoot }/poll/`;

  constructor(private http: HttpAuth) { }

  public getPolls(page?: number, pagecount?: number, invite?: number, query?: string, status?: any[]): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (invite != null) {
      params.append('invite', String(invite));
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (query) {
        params.set('query', query);
    }

    if (status) {
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.pollUrl, options)
      .map(this.extractData)
      .catch((error: any) => Observable.throw(error.json().meta || {message: 'server error', status: 0}));
  }

  public getPolls2(page?: number, pagecount?: number, invite?: number, query?: string, status?: any[]): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (invite != null) {
      params.append('invite', String(invite));
    }

    params.append('invites', String(1));

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (query) {
        params.set('query', query);
    }

    if (status) {
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.pollUrl, options)
      .map(this.extractData)
      .catch((error: any) => Observable.throw(error.json().meta || {message: 'server error', status: 0}));
  }

  public getPollsByJob(page?: number, pagecount?: number, job_id?: string, invite?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (job_id != null) {
      params.append('job_id', String(job_id));
    }

    if (invite != null) {
      params.append('invite', String(invite));
    }
    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.pollUrl, options)
      .map(this.extractData)
      .catch((error: any) => Observable.throw(error.json().meta || {message: 'server error', status: 0}));
  }

  public getPoll(id: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('id', String(id));
    params.append('invites', String(1));

    const options = new RequestOptions({search: params});

    return this.http.get(this.pollUrl, options)
      .map(this.extractData)
      .catch((error: any) => Observable.throw(error.json().meta || {message: 'server error', status: 0}));
  }

  public putPoll(poll: Poll): Observable<Poll> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.put(this.pollUrl, poll, {headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postPoll(poll: Poll): Observable<Poll> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(this.pollUrl, poll, {headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putPollStatus(id, status): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {id: id, status: status};

    const options = new RequestOptions({search: params});

    return this.http.put(this.pollUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deletePoll(pollID): Observable<Poll> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey,
      'id': pollID
    });

    return this.http.delete(this.pollUrl + '?id=' + pollID, {headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    const body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/poll.service.ts